<template>
  <div>
    <w-vue-select
      label-field="name"
      value-field="name"
      :model="$schema.selectedSchool"
      :values="options"
      :ajax="true"
      @input="updateSchoolData"
      @search="search"
    />

    <w-vue-select
      v-if="selectedParentOnly"
      class="mt-2"
      label-field="name"
      value-field="name"
      :model="$schema.selectedSubschool"
      :values="suboptions"
      :ajax="true"
      @input="updateSubschoolData"
      @search="subSearch"
    />
  </div>
</template>

<script>
import { schoolPickerMixin } from '@/mixins/document/schoolPicker';
import { setSchoolDataMixin } from '@/mixins/document/setSchoolData';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/schoolPicker.schema';

// @vuese
// Komponent do wyboru szkoły
// @group document
export default {
  mixins: [formMixin, schoolPickerMixin, setSchoolDataMixin],
  schema,
  props: {
    // Model szkoły
    schoolModel: { type: Object, required: true },
    // Czy szkoły publiczne
    public: { type: Boolean, required: true }
  },
  data() {
    return { suboptions: [] };
  },

  computed: {
    selectedParentOnly() {
      return this.suboptions.length;
    }
  },

  watch: {
    'schoolModel.schoolName.$warnings': function(newVal, oldVal) {
      if (oldVal?.length === 0 && newVal?.length) {
        this.$schema.$validateAll();
      }
    },
    public() {
      this.fullClear();
      this.search();
    }
  },

  methods: {
    // @vuese
    // Wyszukuje szkoły drugiego poziomu (dzieci wybranego zespołu)
    subSearch(search) {
      return this.$store.dispatch('structureNode/list', {
        parentId: this.schoolModel.nodeId.$model,
        filterFields: { isGuided: this.public }
      });
    },

    // @vuese
    // W pełni czyści komponent i dane szkoły
    fullClear() {
      this.clearSchoolData();
      this.$schema.$setData({ selectedSchool: null, selectedSubschool: null });
      this.$schema.$reset();
    },

    // @vuese
    // Czyści dane szkoły
    clearSchoolData() {
      this.schoolModel.nodeId.$setData(null);
      this.schoolModel.schoolType.$setData(null);
      this.schoolModel.reportType.$setData(null);
      this.schoolModel.schoolAddress.$setData({
        city: null,
        street: null,
        nr: null,
        localNr: null,
        postCode: null,
        simc: null,
        ulic: null
      });
      this.schoolModel.isGroup.$setData(null);
      this.schoolModel.subSchoolName.$setData(null);
      this.schoolModel.subSchoolId.$setData(null);
    }
  }
};
</script>
